import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/display.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import Grid from '@material-ui/core/Grid';

import Snackbar from '../../../labels/Snackbar';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import BlueButton from '../../../buttons/BlueButton';
import Display from './Display';

const pagination = 15;

function sortData(arr, search, status) {
    if (!arr) {
        return arr;
    } else {
        const result = []
            .concat(arr)
            .sort((a, b) => (a.txtlocal < b.txtlocal ? -1 : 1))
            .reduce((arr, info) => {
                if (search && search.length > 0) {
                    const filter = search.filter(
                        (s) => info.txtlocal && info.txtlocal.toUpperCase().includes(s),
                    );
                    if (filter && filter.length > 0) {
                        if (
                            (status !== '1' && status !== '2') ||
                            (status === '1') & !info.throttle ||
                            (status === '2') & info.throttle
                        ) {
                            arr.push(info);
                        }
                    }
                } else if (
                    (status !== '1' && status !== '2') ||
                    (status === '1') & !info.throttle ||
                    (status === '2') & info.throttle
                ) {
                    arr.push(info);
                }
                return arr;
            }, []);
        return result;
    }
}

class ListDisplays extends React.Component {
    state = {
        index: 0,
        status: this.props.status,
        search: this.props.search,
        displays: this.props.displays,
        data: sortData(this.props.displays, this.props.search, this.props.status),
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.search !== state.search ||
            props.status !== state.status ||
            props.displays !== state.displays ||
            props.loading !== state.loading
        ) {
            state.search = props.search;
            state.status = props.status;
            state.displays = props.displays;
            state.data = sortData(props.displays, props.search, props.status);
            state.loading = props.loading;
            return state;
        }
        return null;
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    handleClick = (event) => {
        this.setState({ index: this.state.index + pagination });
    };

    handleThrottle = (id, throttle, estado) => {
        if (throttle === 1 || estado !== 3 ) {
            this.props.throttle(id, throttle, estado)
                            .catch((error) => {
                                this.setState({ error: error.message });
                            });
        }
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    render() {
        const { index, data, error } = this.state;
        const { displays_is_loading, displays_has_errored } = this.props;
        const aux = [...data].splice(0, index + pagination);
        const length = data.length;

        if (displays_has_errored.hasErrored) {
            return (
                <Error open type={displays_has_errored.hasErrored}  message={displays_has_errored.error} handleClose={this.handleBack} />
            );
        } else if (data === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_displays_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 padding_top_12 height100'}>
                    {displays_is_loading && <Loading open opacity />}
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    <div className="flex_full overflow_y_scroll" onScroll={this.handleScroll}>
                        {aux.map((u) => {
                            return (
                                <Display
                                    {...this.props}
                                    key={randomstring()}
                                    display={u}
                                    onThrottle={this.handleThrottle}
                                />
                            );
                        })}
                        {length > index + pagination && (
                            <Grid
                                container
                                justify="center"
                                className={'flex_grow_1 align_center margin_top_24'}
                            >
                                <Grid item xs={10} sm={6} className="padding_bottom_12">
                                    <BlueButton id="next" onClick={this.handleClick} />
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </div>
            );
        }
    }
}

ListDisplays.propTypes = {
    displays: PropTypes.array.isRequired,
    displays_is_loading: PropTypes.bool.isRequired,
    displays_has_errored: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        displays: state.displays,
        displays_is_loading: state.displays_is_loading,
        displays_has_errored: state.displays_has_errored,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

ListDisplays = withRouter(ListDisplays);

ListDisplays = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ListDisplays);

export default ListDisplays;



// WEBPACK FOOTER //
// ./src/components/complex/manage/displays/List.js